import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Menus from "../../component/Menu";
import { useTranslation } from "react-i18next";
import { LiaGreaterThanSolid } from "react-icons/lia";
import CurrencyNameSelect from "../../component/CurrencyNameSelect";
import Footer from "../../component/Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import getEsimLists from "../../services/api/eSim/getEsimDetails";
import { AuthUserContext } from "../../context/context";
import Spinner from "react-bootstrap/esm/Spinner";
import { FaLessThan } from "react-icons/fa6";
import OfferCardFilter from "../../component/OfferCardFilter";
import Navbars from "../../component/Navbar/Navbar";
import getCountrys from "../../services/api/getCountry";
import currencyExchange from "../../services/api/currencyyExchange";
import {
  countryCode,
  countryCurrency,
  currencySymbols,
} from "../../constants/currency";
import SortSelect, { options } from "../../component/SortSelect";
import {
  COUNTRY_CURRENCY,
  CURRENCY,
  USER_DETAILS,
} from "../../constants/localstorageKeys";
import { countryList } from "../../constants/countryList";
import RegisterOffers from "../../component/RegisterOffers";
import { useParams } from "react-router-dom";
import FiltersPanel from "../../component/Filters/FiltersPanel";

const CountryFilter = ({}) => {
  const {
    currentLocalization,
    setSelectData,
    selectData,
    setSelectDays,
    selectDay,
    setSelectPrice,
    selectPrice,
    setPackageType,
    packageType,
    user,
    setUser,
    setToastId,
  } = useContext(AuthUserContext);
  const [exchangeRate, setExchangeRate] = useState(1);
  const [currencySymbol, setCurrencySymbol] = useState("$");
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const searchParams = new URLSearchParams(location.search);
  const country = searchParams.get("country");
  const { t } = useTranslation();
  // const countryCurrency = localStorage.getItem(COUNTRY_CURRENCY);
  const currency = localStorage.getItem(CURRENCY);
  const [eSimDetails, setEsimDetails] = useState([]);
  const [filterDetails, setFilterDetails] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [simRecordLength, setSimRecordLength] = useState(0);
  const [getCountryss, setGetCountrys] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const [priceSorting, setPriceSorting] = useState("all");
  const [initialized, setInitialized] = useState(true);
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [visiblePackages, setVisiblePackages] = useState(3);
  const { countries } = useParams();

  const handleShowMore = () => {
    setVisiblePackages(prev => prev + 3);
  };

  const handleCurrencyChange = ({ exchangeRate, currency }) => {
    setExchangeRate(exchangeRate);
    setCurrencySymbol(currency);
  };
  const getCountryDetails = async () => {
    try {
      const countryCode =
        selectedCountry && selectedCountry?.length > 0 && selectedCountry;
      countryList?.forEach((element) => {
        if (element?.cca2 == countryCode) {
          setGetCountrys(element?.name?.common);
        }
      });
    } catch (e) {
      console.log("e", e);
    } finally {
      setLoading(false);
    }
  };
  const globallGetEsim = async (days, price, data, region, lang) => {
    try {
      setLoading(true);
      setSelectedOption(options[0]);
      let countryCode =
        selectedCountry && selectedCountry?.length > 0 ? selectedCountry : "SA";
      if (!Array.isArray(countryCode)) {
        countryCode = [countryCode];
      }
      const countriesParam = countryCode
        .map((country) => `countries[]=${country}`)
        .join("&");
      let langs;
      if (lang === "en-US") {
        langs = "en";
      } else {
        langs = lang;
      }
      const response = await getEsimLists(
        days,
        price,
        data,
        countriesParam,
        region,
        langs,
        user?.id
      );
      let fetchedData = response?.data || [];
      if (priceSorting === "price") {
        let priceSort = fetchedData.sort((a, b) => a.price - b.price);
        setFilterDetails(priceSort);
      } else if (priceSorting === "data") {
        let dataSort = fetchedData.sort((a, b) => b.data - a.data);
        setFilterDetails(dataSort);
      } else if (priceSorting === "validity") {
        let validitySort = fetchedData.sort((a, b) => b.validity - a.validity);
        setFilterDetails(validitySort);
      } else {
        setFilterDetails(fetchedData);
      }
      setFilterDetails(fetchedData);
      setEsimDetails(fetchedData);
      setSimRecordLength(fetchedData.length);
      applyFilters(selectData, selectDay, selectPrice, fetchedData);
    } catch (err) {
      const id = toast.error(err.response?.data?.message || err.message, {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        pauseOnHover: true,
      });
      setToastId(id);
    } finally {
      setLoading(false);
    }
  };
  const getEsimList = async (days, price, data, region, lang) => {
    try {
      setLoading(true);
      setSelectData("");
      setSelectPrice("");
      setSelectDays("");
      setPackageType("");
      let countryCode =
        selectedCountry && selectedCountry?.length > 0 ? selectedCountry : "SA";
      if (!Array.isArray(countryCode)) {
        countryCode = [countryCode];
      }
      const countriesParam = countryCode
        .map((country) => `countries[]=${country}`)
        .join("&");
      let langs;
      if (lang === "en-US") {
        langs = "en";
      } else {
        langs = lang;
      }
      const response = await getEsimLists(
        days,
        price,
        data,
        countriesParam,
        region,
        langs,
        user?.id
      );
      let fetchedData = response?.data || [];
      
      // Complex sorting function that handles both vendor priority and data size priority
      fetchedData.sort((a, b) => {
        // First priority: esimVault packages at the top
        if (a.key === 'esimVault' && b.key !== 'esimVault') return -1;
        if (a.key !== 'esimVault' && b.key === 'esimVault') return 1;

        // Second priority: Within each vendor group, packages with data >= 5 at the top
        if (a.key === b.key) { // When comparing packages from the same vendor
          const aHasEnoughData = a.data >= 5;
          const bHasEnoughData = b.data >= 5;
          
          if (aHasEnoughData && !bHasEnoughData) return -1;
          if (!aHasEnoughData && bHasEnoughData) return 1;
        }
        
        return 0;
      });

      if (priceSorting === "price") {
        let priceSort = fetchedData.sort((a, b) => a.price - b.price);
        setFilterDetails(priceSort);
      } else if (priceSorting === "data") {
        let dataSort = fetchedData.sort((a, b) => b.data - a.data);
        setFilterDetails(dataSort);
      } else if (priceSorting === "validity") {
        let validitySort = fetchedData.sort((a, b) => b.validity - a.validity);
        setFilterDetails(validitySort);
      } else {
        setFilterDetails(fetchedData);
      }
      setFilterDetails(fetchedData);
      setEsimDetails(fetchedData);
      setSimRecordLength(fetchedData.length);
      setVisiblePackages(3); // Reset visible packages when new data is loaded
      // console.log("selectData",selectData, selectDay, selectPrice);
      // applyFilters(selectData, selectDay, selectPrice, fetchedData);
    } catch (err) {
      const id = toast.error(err.response?.data?.message || err.message, {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        pauseOnHover: true,
      });
      setToastId(id);
    } finally {
      setLoading(false);
    }
  };

  const handleDataFilter = async (data) => {
    try {
      setSelectedOption(options[0]);
      setSelectData(data);
      await new Promise(resolve => {
        // Use setTimeout to ensure state updates are processed
        setTimeout(() => {
          applyFilters(data, selectDay, selectPrice, eSimDetails);
          resolve();
        }, 50);
      });
    } catch (e) {
      console.log("Error processing", e);
    }
  };
  const handleDayFilter = async (day) => {
    try {
      setSelectedOption(options[0]);
      setSelectDays(day);
      await new Promise(resolve => {
        setTimeout(() => {
          applyFilters(selectData, day, selectPrice, eSimDetails);
          resolve();
        }, 50);
      });
    } catch (e) {
      console.log("Error processing", e);
    }
  };
  const handlePriceFilter = async (price) => {
    try {
      setSelectedOption(options[0]);
      setSelectPrice(price);
      await new Promise(resolve => {
        setTimeout(() => {
          applyFilters(selectData, selectDay, price, eSimDetails);
          resolve();
        }, 50);
      });
    } catch (e) {
      console.log("Error processing", e);
    }
  };
  const applyFilters = (data, day, price, eSimDetails) => {

    let filteredData = eSimDetails;

    const isUnlimitedData = (itemData) => {
    if (typeof itemData === "string" && itemData.trim().toLowerCase() === "unlimited") {
      return true;
    }
    if (typeof itemData === "number" && itemData === 0) {
      return true;
    }
    return false;
    };

    if (data !== "") {
      filteredData = filteredData
        .filter((item) => {
          const itemData = item.data;
          
          if (data === 0) {
            // return item.data <= 0;
            return isUnlimitedData(itemData);
          }
          return data < 0
            ? item.data == data
            : item.data >= data || item.data <= 0;
        })
        .sort((a, b) => {
          if (a.data === 0 || a.data === -0.001) return 1;
          if (b.data === 0 || b.data === -0.001) return -1;
          return a.data - b.data;
        });
    }
    if (day !== "") {
      filteredData = filteredData
        .filter((item) => item.validity >= day)
        .sort((a, b) => a.validity - b.validity);
    }
    if (price !== "") {
      filteredData = filteredData
        .filter((item) => item.price <= price)
        .sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
    }
    setSimRecordLength(filteredData?.length);
    setFilterDetails(filteredData);
  };
  const handlePackageType = async (data) => {
    setPackageType(data);
    if (data == "Global") {
      await globallGetEsim("", "", "", "Global", currentLocalization);
    } else if (data == "countryName") {
      await globallGetEsim("", "", country, getCountryss, currentLocalization);
    } else {
      await globallGetEsim("", "", country, "", currentLocalization);
    }
  };
  const handleAllFilter = () => {
    try {
      setSelectData("");
      setSelectPrice("");
      setSelectDays("");
      setVisiblePackages(3); // Reset visible packages when filters are cleared
      if (packageType === "Global" || packageType === "countryName") {
        getEsimList("", "", country, "", currentLocalization);
      }
      setPackageType("");

      setSimRecordLength(eSimDetails?.length);
      setFilterDetails(eSimDetails);
    } catch (e) {
      console.log("Error processing", e);
    }
  };
  const handleSorting = () => {
    if (priceSorting === "price") {
      const sortedESimDetails = [...eSimDetails].sort(
        (a, b) => a.price - b.price
      );
      setFilterDetails(sortedESimDetails);
    } else if (priceSorting === "data") {
      const sortedESimDetails = [...eSimDetails].sort((a, b) => {
        if (a.data <= 0 && b.data > 0) return -1;
        if (b.data <= 0 && a.data > 0) return 1;
        return b.data - a.data;
      });
      setFilterDetails(sortedESimDetails);
    } else if (priceSorting === "validity") {
      const sortedESimDetails = [...eSimDetails].sort(
        (a, b) => b.validity - a.validity
      );
      setFilterDetails(sortedESimDetails);
    } else {
      setFilterDetails(eSimDetails);
    }
  };

  const currencyCHange = async () => {
    try {
      if (currency) {
        const getCountryCurrency = countryCurrency.find(
          (code) => code.currency_code === currency
        );
        const country = countryCode.find(
          (country) => country.countryName === getCountryCurrency.country_code
        );
        const newCurrency = country ? country.countryCurrency : "USD";
        const currencyCode =
          currencySymbols.find((symbol) => symbol.Code === newCurrency)
            ?.Symbol ?? currency;
        setCurrencySymbol(currencyCode);
        setSelectedCurrency(newCurrency);
        const response = await currencyExchange();
        const exchangeRate = response.rates[newCurrency];
        setExchangeRate(exchangeRate);
      }
    } catch (e) {
      console.log("e", e);
    }
  };
  const path = window.location.pathname;
  const paths = path.split("/")[1];

  useEffect(() => {
    const countryListParams = paths ? paths.split(",") : [];
    const result = countryListParams
      .map((param) => {
        const match = countryList.find(
          (country) =>
            country.name.common.toLowerCase().replace(/\s+/g, "") === param
        );
        return match?.cca2;
      })
      .filter(Boolean);
    setSelectedCountry(result);
    // if (result?.length <= 0 || result == undefined) {
    //   // const queryParams = new URLSearchParams(window.location.search);
    //   // queryParams.set("country", country || "SA");
    //   const newUrl = `/saudiarabia`;
    //   window.history.pushState({ path: newUrl }, "", newUrl);
    // }
    const userDetails = JSON.parse(localStorage.getItem(USER_DETAILS));
    if (userDetails) {
      setUser(userDetails);
      setInitialized(false);
    } else {
      setInitialized(false);
    }
  }, [paths?.length]);
  useEffect(() => {
    getCountryDetails();
    if (selectedCountry.length > 0) {
      getEsimList("", "", "", "", currentLocalization);
    }
  }, [currentLocalization, selectedCountry]);
  useEffect(() => {
    currencyCHange();
    localStorage.removeItem("OUTSIDER_USER");
  }, []);
  useEffect(() => {
    handleSorting();
  }, [priceSorting]);

  return (
    <div>
      <Navbars />
      <Menus
        text={t("countryFilter.part1")}
        textGb={t("countryFilter.part2")}
        textWork={t("home.part16")}
        showSelect={true}
        setSelectedCountry={setSelectedCountry}
        country={country || selectedCountry[0]}
        selectedCountry={selectedCountry}
        getCountrys={t(`countryName.${getCountryss}`)}
        status="country-filter"
        getCountryss={getCountryss}
      />
      <section className="offers-image ">
        <Container className="p-md-0">
          <Row
            className={`d-flex justify-content-center ${
              currentLocalization == "ar" && "me-2"
            }`}
          >
            <Col
              className={`text-start mt-4 ps-md-0 ${
                currentLocalization == "ar" && " d-flex flex-row-reverse"
              }`}
              xs={12}
              md={12}
            >
              <span
                className="country-name-span"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/")}
              >
                {t("navbar.home")}
              </span>
              {currentLocalization == "ar" ? (
                <span className="country-name-span me-1 ms-1">
                  <FaLessThan size={11} />
                </span>
              ) : (
                <span className="country-name-span ms-1">
                  <LiaGreaterThanSolid size={11} />
                </span>
              )}
              <span className="country-name-span ">
                <b>
                  &nbsp;{t("home.part24")} {t(`countryName.${getCountryss}`)}
                </b>
              </span>
            </Col>
            <p
              className={`discovery-p text-start p-md-0 mt-3 ${
                currentLocalization == "ar" && "d-flex flex-row-reverse"
              }`}
            >
              {t("countryFilter.part3")} {t(`countryName.${getCountryss}`)}
              &nbsp;{t("countryFilter.part30")}
            </p>
          </Row>
          <Row
            className={
              currentLocalization == "ar"
                ? "pb-4 me-2 show-banner"
                : "pb-4 me-1 ms-1 ms-lg-0 me-lg-3"
            }
          >
            <Col className="text-start p-0 ">
              {!initialized && (
                <>{user.length !== 0 ? <></> : <RegisterOffers />}</>
              )}
            </Col>
          </Row>

          <Row className={`p-0 mb-0 ${currentLocalization == "ar" && "me-2"}`}>
            <Col
              xs={12}
              className={`d-flex flex-column flex-lg-row justify-content-between align-items-center p-md-0 pe-md-4 pe-lg-0 ${
                currentLocalization == "ar" && "flex-row-reverse"
              }`}
            >
              <span className="show-product-p">
                {t("countryFilter.part4")} {!loading && simRecordLength}
                &nbsp;{t("countryFilter.part")}
              </span>
              <div
                className={`d-flex flex-column flex-md-row ${
                  currentLocalization == "ar"
                    ? "select-box-padding-right"
                    : "select-box-padding"
                }`}
              >
                <CurrencyNameSelect
                  onCurrencyChange={handleCurrencyChange}
                  selectedCurrency={selectedCurrency}
                  setSelectedCurrency={setSelectedCurrency}
                  className={"select-field-class"}
                />
                <div className="ms-3">
                  <SortSelect
                    setPriceSorting={setPriceSorting}
                    setSelectData={setSelectData}
                    setSelectDays={setSelectDays}
                    setSelectPrice={setSelectPrice}
                    setSelectedOption={setSelectedOption}
                    selectedOption={selectedOption}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row
            className={`d-flex flex-row justify-content-center  ${
              currentLocalization == "ar" && "flex-row-reverse"
            }`}
          >
            <Col
              lg={3}
              md={3}
              xs={11}
              className={`text-start ps-0 pe-0  mb-4 mt-4 ${
                currentLocalization == "ar" && "text-end"
              }`}
            >
              <FiltersPanel
                currentLocalization={currentLocalization}
                loading={loading}
                showPackageType={true}
                packageType={packageType}
                onPackageType={handlePackageType}
                selectData={selectData}
                selectDay={selectDay}
                selectPrice={selectPrice}
                onDataFilter={handleDataFilter}
                onDayFilter={handleDayFilter}
                onPriceFilter={handlePriceFilter}
                onClearAll={handleAllFilter}
              />
            </Col>

            <Col md={9} xs={11} className="">
              {loading ? (
                <div
                  className="w-100 d-flex justify-content-center align-items-center"
                  style={{ paddingTop: "150px", paddingBottom: "150px" }}
                >
                  <Spinner animation="border" variant="dark" />
                </div>
              ) : (
                <Row className="mt-3">
                  <Col
                    xs={12}
                    className={`d-flex flex-wrap p-0 ${
                      currentLocalization == "ar"
                        ? "justify-content-start"
                        : "justify-content-start"
                    }`}
                  >
                    {filterDetails?.length > 0 ? (
                      <>
                        {filterDetails
                          ?.filter(item => !(user?.isFreeSim && item.isFree))
                          .sort((a, b) => {
                            if (a.isFree && !b.isFree) return -1;
                            if (!a.isFree && b.isFree) return 1;
                            return 0;
                          })
                          .slice(0, visiblePackages)
                          .map((item, index) => {
                            return (
                              <OfferCardFilter
                                item={item}
                                key={index}
                                index={index}
                                offers={eSimDetails}
                                exchangeRate={exchangeRate}
                                currencySymbol={currencySymbol}
                                getCountryss={getCountryss}
                                user={user}
                                packageType={packageType}
                              />
                            );
                          })}
                        {filterDetails.length > visiblePackages && (
                          <div className="w-100 d-flex justify-content-center mt-4">
                            <button
                              className="filter-button"
                              onClick={handleShowMore}
                              style={{
                                minWidth: "150px",
                                padding: "10px 20px",
                                fontSize: "16px",
                                cursor: "pointer",
                              }}
                            >
                              {t("countryFilter.part37")}
                            </button>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="w-100 pt-5 pb-5">
                        <span>{t("home.part28")}</span>
                      </div>
                    )}
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
          <Row className="d-flex mt-5 justify-content-center">
            <Col className="m-0 p-0" md={12} xs={11}>
              <Footer />
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default CountryFilter;
